import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from '../Assets/Logo.png';
import SignOut from './SignOut'; 
import Footer from '../home/Footer'; // Import your Footer component

const QuiltBuilderWithLayout = ({ handleReset, handleSoftReset, children, isGenerated }) => {
    const navigate = useNavigate();
    const [isResetMenuOpen, setIsResetMenuOpen] = useState(false);
    const resetMenuRef = useRef(null);

    const toggleResetMenu = () => {
        setIsResetMenuOpen(!isResetMenuOpen);
    };

    // Add click outside detection to close the dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (resetMenuRef.current && !resetMenuRef.current.contains(event.target)) {
                setIsResetMenuOpen(false);
            }
        };

        // Attach the listener to the document
        if (isResetMenuOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }
        
        // Clean up the listener
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isResetMenuOpen]);

    return (
        <div className="min-h-screen flex flex-col bg-white">
            {/* Header */}
            <header className="fixed top-0 w-full bg-zinc-300 py-6 shadow-md z-50">
                <div className="container mx-auto flex justify-between items-center px-4 sm:px-10">
                    {/* Logo */}
                    <div className="flex items-center">
                        <img 
                            src={logo} 
                            onClick={() => navigate('/')} 
                            alt="Logo" 
                            className="w-50 h-10 mr-2 cursor-pointer"
                        />
                    </div>

                    {/* Navigation */}
                    <nav className="space-x-4 sm:space-x-8 flex items-center">
                        {/* Reset Button with Dropdown */}
                        <div className="relative" ref={resetMenuRef}>
                            <button
                                onClick={toggleResetMenu}
                                className="text-sm sm:text-base text-black hover:underline flex items-center"
                                style={{ fontFamily: "Playfair Display" }}
                            >
                                {isGenerated ? "Reset" : "New"} 
                                <svg 
                                    className={`ml-1 w-4 h-4 transition-transform ${isResetMenuOpen ? 'transform rotate-180' : ''}`}
                                    fill="none" 
                                    stroke="currentColor" 
                                    viewBox="0 0 24 24" 
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
                                </svg>
                            </button>
                            
                            {/* Dropdown Menu */}
                            {isResetMenuOpen && (
                                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-10">
                                    {isGenerated && (
                                        <button
                                            onClick={() => {
                                                handleSoftReset();
                                                setIsResetMenuOpen(false);
                                            }}
                                            className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                            style={{ fontFamily: "Playfair Display" }}
                                        >
                                            Reset Layout (keep clothes)
                                        </button>
                                    )}
                                    <button
                                        onClick={() => {
                                            handleReset();
                                            setIsResetMenuOpen(false);
                                        }}
                                        className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                        style={{ fontFamily: "Playfair Display" }}
                                    >
                                        {isGenerated ? "Start New Project (clear all)" : "New Project"}
                                    </button>
                                </div>
                            )}
                        </div>
                        <SignOut />
                    </nav>
                </div>
            </header>

            {/* Page Content */}
            <main className="flex-grow mt-16 sm:mt-20 px-4 sm:px-10 bg-[#F6E8E0]">
                {children} {/* Render the page content */}
            </main>

            {/* Footer */}
            <Footer />
        </div>
    );
};

export default QuiltBuilderWithLayout;
